import { PUI } from '@pui/react';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import RenderRouter from './routes';

PUI.setDefaultSize('small');
PUI.changeLang('zh-CN');

function App(): JSX.Element {
  return (
    <RecoilRoot>
      <BrowserRouter>
        <Suspense fallback={<>...</>}>
          <RenderRouter />
        </Suspense>
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default App;
